import { xBaseTheme } from "@eisinc/XDL/types";

import button from "@eisinc/XDL/PreStyle/button";

import accordion from "@eisinc/XDL/PreStyle/accordion";
import breadcrumbs from "@eisinc/XDL/PreStyle/breadcrumbs";
import breakpoints from "@eisinc/XDL/PreStyle/breakpoints";
import checkbox from "@eisinc/XDL/PreStyle/checkbox";
import colors from "@eisinc/XDL/PreStyle/colors";
import dataTable from "@eisinc/XDL/PreStyle/dataTable";
import datePicker from "@eisinc/XDL/PreStyle/datePicker";
import drawer from "@eisinc/XDL/PreStyle/drawer";
import dynamicDropdown from "@eisinc/XDL/PreStyle/dynamicDropdown";
import formField from "@eisinc/XDL/PreStyle/formField";
import globalStyle from "@eisinc/XDL/PreStyle/globalStyle";
import header from "@eisinc/XDL/PreStyle/header";
import helpers from "@eisinc/XDL/PreStyle/helpers";
import link from "@eisinc/XDL/PreStyle/link";
import lists from "@eisinc/XDL/PreStyle/lists";
import menu from "@eisinc/XDL/PreStyle/menu";
import modal from "@eisinc/XDL/PreStyle/modal";
import pagination from "@eisinc/XDL/PreStyle/pagination";
import panelMenu from "@eisinc/XDL/PreStyle/panelMenu";
import radio from "@eisinc/XDL/PreStyle/radio";
import tab from "@eisinc/XDL/PreStyle/tab";
import tag from "@eisinc/XDL/PreStyle/tag";
import toast from "@eisinc/XDL/PreStyle/toast";
import tooltip from "@eisinc/XDL/PreStyle/tooltip";
import typography from "@eisinc/XDL/PreStyle/typography";
import zIndex from "@eisinc/XDL/PreStyle/zIndex";

export default {
    breakpoints,
    colors,
    // focus,
    // shadows,
    // transition,
    globalStyle,
    header,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    formField,
    // fieldSet,
    // icon,
    link,
    lists,
    // lazyImage,
    // loadingSpinner,
    // menu,
    modal,
    // overflowMenu,
    pagination,
    panelMenu,
    radio,
    // select,
    tab,
    tag,
    // textField,
    // tokenExFrame,
    // textArea,
    toast,
    tooltip,
    // translate,
    helpers,
    menu,
} as xBaseTheme;
